import { render, staticRenderFns } from "./MoreFiltersBtn.vue?vue&type=template&id=3bf0d4c8&scoped=true"
import script from "./MoreFiltersBtn.vue?vue&type=script&lang=js"
export * from "./MoreFiltersBtn.vue?vue&type=script&lang=js"
import style0 from "./MoreFiltersBtn.vue?vue&type=style&index=0&id=3bf0d4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0d4c8",
  null
  
)

export default component.exports